<script setup lang="ts">
definePage({
  meta: {
    title: '个人中心',
    auth: true,
  },
})
</script>

<template>
  <FmPageLayout navbar tabbar class="page">
    <div class="flex items-center gap-10px p-b-10px p-l-18px p-r-18px p-t-10px">
      <FmIcon name="carbon:user-avatar-filled-alt" class="text-59px color-[#999]" />
      <div class="flex-1 text-18px">
        <div class="flex items-center justify-between">
          <span>用户887564</span>
        </div>
        <div class="text-9px color-[#666]">
          某某宝号：887557900
        </div>
      </div>
      <FmIcon name="ic:round-keyboard-arrow-right" class="text-20px color-[#999]" />
    </div>
    <div class="rounded-10px bg-[#fff]">
      <div class="flex p-l-10px p-r-10px">
        <div class="w-25% p-b-10px p-t-10px text-center">
          <FmIcon name="material-symbols-light:kid-star-sharp" class="text-28px color-[#3C78FF]" />
          <div>我的关注</div>
          <div>268</div>
        </div>
        <div class="w-25% p-b-10px p-t-10px text-center">
          <FmIcon name="material-symbols:broken-image" class="text-28px color-[#3C78FF]" />
          <div>行情服务</div>
          <div>23</div>
        </div>
        <div class="w-25% p-b-10px p-t-10px text-center">
          <FmIcon name="uis:comment-dots" class="text-28px color-[#3C78FF]" />
          <div>我的评论</div>
          <div>45</div>
        </div>
        <div class="w-25% p-b-10px p-t-10px text-center">
          <FmIcon name="material-symbols:favorite-rounded" class="text-28px color-[#3C78FF]" />
          <div>我的收藏</div>
          <div>89</div>
        </div>
      </div>
      <van-cell-group>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="material-symbols:browse-activity-outline" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">模拟交易</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="icon-park-outline:coupon" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">我的礼券</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="mdi:help-circle-outline" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">帮助中心</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="iconamoon:gift" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">热门活动</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="ri:coupon-3-line" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">优惠券</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="material-symbols:person-check-outline" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">邀请好友</span>
            </div>
          </template>
        </van-cell>
        <van-cell is-link>
          <template #title>
            <div class="flex items-center">
              <FmIcon name="fluent:people-community-12-regular" class="m-r-10px text-18px color-[#3C78FF]" />
              <span class="custom-title font-500">加入社群</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <div class="text-center text-17px color-[#E51A2D] font-500 line-height-51px">
        退出登录
      </div>
    </div>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.page {
  padding: 7px;
  padding-top: 0;

  :deep(.van-cell) {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
</style>
